"use client";
import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { Root as v, Track as u, Range as g, Thumb as w } from "@radix-ui/react-slider";
import { cva as y } from "class-variance-authority";
import * as N from "react";
import { cn as o } from "./index23.mjs";
const A = y("", {
  variants: {
    variant: {
      light: "bg-white",
      dark: "bg-gray-800"
    }
  }
}), T = ({
  className: c,
  defaultValue: a,
  value: t,
  min: l = 0,
  max: n = 100,
  variant: f = "dark",
  trackProps: e = {},
  thumbProps: i = {},
  rangeProps: r = {},
  ...h
}) => {
  const b = N.useMemo(() => Array.isArray(t) ? t : Array.isArray(a) ? a : [l, n], [t, a, l, n]);
  return /* @__PURE__ */ m(
    v,
    {
      "data-slot": "slider",
      defaultValue: a,
      value: t,
      min: l,
      max: n,
      className: o([
        "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        c
      ]),
      ...h,
      children: [
        /* @__PURE__ */ s(
          u,
          {
            "data-slot": "slider-track",
            ...e,
            className: o(
              "bg-gray-400 relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1",
              (e == null ? void 0 : e.className) || ""
            ),
            children: /* @__PURE__ */ s(
              g,
              {
                "data-slot": "slider-range",
                ...r,
                className: o(
                  "absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full",
                  A({ variant: f }),
                  (r == null ? void 0 : r.className) || ""
                )
              }
            )
          }
        ),
        Array.from({ length: b.length }, (x, d) => /* @__PURE__ */ s(
          w,
          {
            "data-slot": "slider-thumb",
            "aria-label": `slider-thumb-${d + 1}`,
            ...i,
            className: o(
              "border-primary bg-background ring-ring/50 block relative size-5 before:absolute before:inset-[-2px] before:content-[''] shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-5 focus-visible:ring-5 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer",
              (i == null ? void 0 : i.className) || ""
            )
          },
          d
        ))
      ]
    }
  );
};
export {
  T as Slider
};
